/* eslint-disable import/prefer-default-export */

import { CultureIndexMapData, CultureIndexMapDataResponse } from 'types/Meteorology/Agro/CultureIndex/Area/getMapData';

export function transformGetMapDataResponse(
  response: CultureIndexMapDataResponse,
): CultureIndexMapData {
  // A API retorna com duplo aninhamento: response.data.data.data
  return (response.data as any).data.data;
}
